import initializeComponent from '../Shared/react-initialize';
import { ProductReviews } from '@ifixit/product-page-components';

const defaultProps = {
   reviewsLink: window.cart_constants.GuideURI('USER_REVIEWS_LINK'),
};

initializeComponent('ProductReviews', ProductReviews, defaultProps);
